"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
function Collapse(props) {
    return (0, jsx_runtime_1.jsx)(antd_1.Collapse, __assign({ ghost: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Collapse.Panel, __assign({ header: props.title }, { children: props.children }), "1") }));
}
exports.Collapse = Collapse;
